'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './adminMembers.routes';
import { ModalBase } from '../../shared/modal.base';
import { SortingBase } from '../../shared/sorting.base';

export class AdminMembersComponent extends ModalBase {
  getCurrentUser: Function;
  users: Object[];
  $scope: Object;
  sorting: SortingBase = new SortingBase();

  /*@ngInject*/
  constructor(User, $uibModal, Auth, $scope) {
    super($uibModal);
    this.$scope = $scope;
    this.users = User.query(users => {
      users.forEach(user => {
        if(user.membership === undefined) {
          user.membership = {
            creationDate: ''
          };
        } else if (!user.membership.creationDate) {
          user.membership.creationDate = '';
        }
      });
    });

    this.getCurrentUser = Auth.getCurrentUserSync;

    // Sorting by default by creation date
    this.sorting.changeSortBy('membership.creationDate');
  }

  getResolve(user) {
    return {
      user: function () {
        return user;
      }
    }
  }

  /**
   * Sorting by member name
   */
  sortByName() {
    this.sorting.changeSortBy('membership.lastName');
    this.sorting.changeSortDirection();
  }

  /**
   * Sorting by membership creation date
   */
  sortByDate() {
    this.sorting.changeSortBy('membership.creationDate');
    this.sorting.changeSortDirection();
  }

  delete(user) {
    let scope = this;
    this.modal('adminMemberDelete', this.getResolve(user), (user) => {
      scope.users.splice(scope.users.indexOf(user), 1);
    });
  }

  edit(user) {
    this.modal('adminMemberEdit', this.getResolve(user), (editedUser) => {
      _.assign(user, editedUser);
    });
  }

  create() {
    let scope = this;
    this.modal('adminMemberEdit', this.getResolve(null), (user) => {
      scope.users.push(user);
    });
  }

  changePassword(user) {
    this.modal('adminMemberPassword', this.getResolve(user), (user) => {});
  }

  exportEmails() {
    let scope = this;
    this.modal('adminMemberExportEmails', {
      users: function () {
        return scope.users;
      }
    }, null);
  }
}

export default angular.module('terrappApp.adminMembers', [
    'terrappApp.auth',
    uiRouter
  ])
  .config(routes)
  .component('adminMembers', {
    template: require('./adminMembers.html'),
    controller: AdminMembersComponent,
    controllerAs: '$ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/adminMembers/adminMembers.component.ts